import type { RemoteMetaCampaign } from './campaignsApi';

export function campaignOriginOptions(campaigns: RemoteMetaCampaign[]) {
  return campaigns.map(campaign => {
    const status = String(campaign.status || campaign.effectiveStatus || '').toUpperCase();
    const reason = campaign.isImported ? 'Já vinculada a um card'
      : !['ACTIVE', 'PAUSED'].includes(status) ? 'Arquivada ou indisponível' : null;
    return { id: campaign.id, disabled: Boolean(reason),
      label: `${campaign.name} (${campaign.id})${reason ? ` — ${reason}` : ''}` };
  });
}

export function campaignOriginSummary(total: number, available: number) {
  if (!total) return 'A Meta não retornou campanhas nesta conta.';
  if (!available) return `${total} campanha(s) encontrada(s). Todas já vinculadas ou indisponíveis para vínculo.`;
  return `${total} campanha(s) encontrada(s). ${available} disponível(is) para vínculo.`;
}
